export default "__VITE_ASSET__DzcPYIgE__"